import {deserialize, deserializeAs, serialize, serializeAs} from 'libs/cerialize';
import { MsAccessColumnDto } from './MsAccessColumnDto';

export class DesktopFolderDto {


	@deserialize
	Path: string;
}
